import cx from "classnames";
import { CSSProperties, ReactNode } from "react";

import DraggableItem from "ds/components/DraggableItem";

import styles from "./styles.module.css";
import { SCALING_FACTOR } from "./constants";
type DragDropListOverlayProps = {
  component?: ReactNode;
  className?: string;
  noBorder?: boolean;
  size?: "small" | "medium";
};

const DragDropListOverlay = ({
  component,
  className,
  noBorder,
  size = "small",
}: DragDropListOverlayProps) => {
  if (!component) {
    return null;
  }

  return (
    // div is needed to have proper animation when we drop element and animation of snapping item to the final position starts
    // Without it we have broken measurement because of using scale transformation to indicate dragged item
    <div>
      <DraggableItem
        noBorder={noBorder}
        size={size}
        margin="0 0 x-large 0"
        style={
          {
            "--scaling-factor": SCALING_FACTOR,
          } as CSSProperties
        }
        className={cx(styles.draggable, styles.overlay, className)}
        dragging={true}
        tabIndex={-1}
        data-animation
      >
        {component}
      </DraggableItem>
    </div>
  );
};

export default DragDropListOverlay;
